'use client';

import { text } from '@mage-ui/styled-system/recipes';
import { CourseRow } from '../course-row/CourseRow';

export const LanguageCourseInfo = ({ data, texts, ...props }) => {
  return (
    <CourseRow
      data={{
        name: data?.language?.fields?.name || data?.name,
        iso:
          data?.language?.fields?.alias ||
          data?.language?.fields?.iso ||
          data?.iso,
      }}
      {...props}
    >
      <p className={text({ size: '1', weight: 'medium' })}>
        {texts?.selectedCourse}{' '}
        <strong>
          {`${data?.course?.fields?.title || data?.title} - `}

          {data.group?.fields?.schedule}

          {data?.courseType?.fields?.title
            ? ` - ${data.courseType?.fields?.title}`
            : ''}
        </strong>
      </p>
      <p className={text({ size: '1', weight: 'medium' })}>
        {data?.availability ? texts?.available : texts?.notAvailable}
      </p>
      {texts?.intro && (
        <p className={text({ size: '1', weight: 'medium' })}>
          {data?.availability ? texts?.intro : texts.introNotAvailable}
        </p>
      )}
    </CourseRow>
  );
};
